import { IResolvers, IClientService, ConfigurationScope } from '@workbench-stack/core';

const configurationResolvers: (services: () => IClientService) => IResolvers<IClientService> = (services) => ({
    ConfigurationScope: {
        APPLICATION: 1,
        MACHINE: 2,
        WINDOW: 3,
        RESOURCE: 4,
    },

    ConfigurationTarget: {
        USER: 1,
        USER_LOCAL: 2,
        USER_REMOTE: 3,
        WORKSPACE: 4,
        WORKSPACE_FOLDER: 5,
        DEFAULT: 6,
        MEMORY: 7,
    },

    Query: {

    }

});

export { configurationResolvers };


